import {
  SHOULD_HIDE_INSTANT_REPORT_FACILITY_IDS,
  SHOULD_HIDE_INSTANT_REPORT_ORGANIZATION_IDS,
} from '@/shared/config';
import { auth } from '@/shared/lib';
import facilitySelection from '../model/facilitySelection';

/**
 * Decides whether the Instant Report tab must be hidden for the current user. Matches the user's support facilities against the facility and organization id deny lists and also checks the user's own organization id, which covers opening the diagnostic portal from the admin portal.
 *
 * @returns A truthy value when the Instant Report tab must be hidden.
 */
const checkHideInstantReportTab = () => {
  const userSupportFacilities = facilitySelection.userSupportFacilities();
  const userOrganization = auth.userOrganization();
  return (
    userSupportFacilities.find(
      (supportFacility: any) =>
        SHOULD_HIDE_INSTANT_REPORT_FACILITY_IDS.includes(supportFacility.id) ||
        SHOULD_HIDE_INSTANT_REPORT_ORGANIZATION_IDS.includes(supportFacility.organization?.id), // handle case open diagnostic portal from admin portal (admin user doesn't have organization but support facility has organization)
    ) || SHOULD_HIDE_INSTANT_REPORT_ORGANIZATION_IDS.includes(userOrganization?.id)
  );
};

export { checkHideInstantReportTab };
